import React from 'react';
import { Link, NavLink } from 'react-router-dom';

export default function Nav() {
  return (
    <nav id="nav">
      <div className='logo'>
        <Link to="/">
          <img src="/images/logo.png" alt="" />
        </Link>
      </div>
      <div className='menu'>
        <ul>
          <li><NavLink end to="/"><span><i className='fa fa-chart-simple'></i></span> Tableau de bord</NavLink></li>
          <li><NavLink to="/tasks"><span><i className='fa fa-calendar-alt'></i></span> Suivi-ASA</NavLink></li>
          <li><NavLink to="/expenses"><span><i className='fa fa-money-bill'></i></span> Gestion des dépenses</NavLink></li>
          <li><NavLink to="/employees"><span><i className='fa fa-users'></i></span> Employés</NavLink></li>
          <li><NavLink to="/raw-materials"><span><i className='fa fa-align-left'></i></span> Matières premières</NavLink></li>
          <li><NavLink to="/packagings"><span><i className='fa fa-box-open'></i></span> Packagings</NavLink></li>
          <li><NavLink to="/categories"><span><i className='fa fa-tag'></i></span> Catégories</NavLink></li>
          <li><NavLink to="/products"><span><i className='fa fa-box-open'></i></span> Produits</NavLink></li>
          <li><NavLink to="/orders"><span><i className='fa fa-shopping-cart'></i></span> Commandes</NavLink></li>
          <li><NavLink to="/suppliers"><span><i className='fa fa-building'></i></span> Fournisseurs</NavLink></li>
          <li><NavLink to="/clients"><span><i className='fa fa-building'></i></span> Clients</NavLink></li>
          <li><NavLink to="/proforma-invoices"><span><i className='fa fa-file'></i></span> Factures proformas</NavLink></li>
          <li><NavLink to="/invoices"><span><i className='fa fa-file'></i></span> Factures</NavLink></li>
          <li><NavLink to="/delivry-notes"><span><i className='fa fa-file'></i></span> Bons de livraison</NavLink></li>
          <li><NavLink to="/users"><span><i className='fa fa-user'></i></span> Utilisateurs</NavLink></li>
          <li><NavLink to="/articles"><span><i className='fa fa-newspaper'></i></span> Articles</NavLink></li>
          <li><NavLink to="/settings"><span><i className='fa fa-cog'></i></span> Paramètres</NavLink></li>
        </ul>
      </div>
    </nav>
  )
}
